// extracted by css-extract-rspack-plugin
export default {"stateReasonLink":"ClosedEvent-module__stateReasonLink__X7TkZ","closerLink":"ClosedEvent-module__closerLink__RF1aK"};